export default __webpack_public_path__ + "static/media/up-arrow.f199d252.svg";